import React, { useEffect, useState } from "react";
import Api, { USER_API_URL } from "../../../Data/Api";
import "./Activities.css";
import { Link } from "react-router-dom";

export default function Activities() {
  const [imagesList, setImagesList] = useState([]);

  useEffect(() => {
    fetchImages();
  }, []); // fetch once on mount

  async function fetchImages() {
    try {
      const res = await Api.getImage();
      if (res.data && res.data !== "No data") {
        setImagesList(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch activities:", err);
    }
  }

  return (
    <section className="activities-home-section" aria-labelledby="activities-heading">
      <div className="container">
        {/* Header */}
        <div className="activities-home-header" data-aos="fade-up">
          <div className="section-label">
            <ion-icon name="camera-outline"></ion-icon>
            Community Outreach
          </div>
          <h2 id="activities-heading">Yita Life Activities</h2>
          <p>
            Yita Life Community Outreach &amp; Social Corporate Responsibility
            - bringing healthcare directly to communities.
          </p>
        </div>

        {/* Activity Images */}
        {imagesList.length === 0 ? (
          <div className="activities-empty">
            <ion-icon name="images-outline" style={{ fontSize: "48px", display: "block", margin: "0 auto 16px", color: "var(--mid-gray)" }}></ion-icon>
            No activities posted yet. Check back soon!
          </div>
        ) : (
          <div className="activities-grid">
            {imagesList.map((item, index) => (
              <div
                className="activity-img-col"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={Math.min(index * 60, 400)}
              >
                <img
                  src={`${USER_API_URL}/${item.Link}`}
                  alt={item.caption || `Activity ${index + 1}`}
                />
                {item.caption && (
                  <div className="activity-caption">{item.caption}</div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* View All Button */}
        <div className="activities-cta" data-aos="fade-up">
          <Link to="/Activity">
            View All Activities
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </Link>
        </div>
      </div>
    </section>
  );
}
